import React, { useRef, useState, useEffect } from 'react';
import { useRegisterMutation } from '../../redux/api/authApi';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import MetaData from '../layout/MetaData';
import ReCAPTCHA from 'react-google-recaptcha';
import '../../css/register.css';

const SITE_KEY = process.env.REACT_APP_SITE_KEY;

const Register = () => {
  const [user, setUser] = useState({ name: '', email: '', phoneNo: '', password: '' });
  const [recaptchaValue, setRecaptchaValue] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const captchaRef = useRef();
  const navigate = useNavigate();

  const { name, email, phoneNo, password } = user;
  const [register, { isLoading, error, data }] = useRegisterMutation();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      toast.error('Logout to access this resource');
    }
    if (error) toast.error(error?.data?.message);
    if (data) {
      if (data.token) localStorage.setItem('authToken', data.token);
      if (email) localStorage.setItem('pendingEmail', email);
      if (phoneNo) localStorage.setItem('phoneNo', phoneNo);
      navigate('/verify-email');
    }
  }, [error, isAuthenticated, data, navigate]);

  const onInputChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });

  const submitHandler = (e) => {
    e.preventDefault();
    if (!recaptchaValue) { toast.error('Please complete the CAPTCHA verification.'); return; }
    if (!termsAccepted) { toast.error('You must accept the Terms and Conditions to register.'); return; }
    register({ name, email, phoneNo, password, recaptchaValue, termsAndAgreement: termsAccepted }, { withCredentials: true });
    captchaRef.current.reset();
  };

  return (
    <>
      <MetaData title="Register" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h2 className="mb-4 text-center">Create Account</h2>

            <div className="mb-3">
              <label htmlFor="name_field" className="form-label">Full Name</label>
              <input type="text" id="name_field" className="form-control" name="name" value={name} onChange={onInputChange} placeholder="Your full name" required />
            </div>

            <div className="mb-3">
              <label htmlFor="email_field" className="form-label">Email</label>
              <input type="email" id="email_field" className="form-control" name="email" value={email} onChange={onInputChange} placeholder="you@example.com" required />
            </div>

            <div className="mb-3">
              <label htmlFor="phoneNo_field" className="form-label">Phone Number</label>
              <input type="tel" id="phoneNo_field" className="form-control" name="phoneNo" value={phoneNo} onChange={onInputChange} placeholder="03XXXXXXXXX" maxLength={11} required />
            </div>

            <div className="mb-3">
              <label htmlFor="password_field" className="form-label">Password</label>
              <input type="password" id="password_field" className="form-control" name="password" value={password} onChange={onInputChange} placeholder="Create a password" required />
            </div>

            <div className="mb-2">
              <div className="form-check">
                <input type="checkbox" className="form-check-input" id="termsCheck" checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} />
                <label className="form-check-label" htmlFor="termsCheck">
                  I accept the <Link to="/Terms-And-Agreement">Terms and Conditions</Link>.
                </label>
              </div>
            </div>

            <div className="mb-3">
              <div className="form-check">
                <input type="checkbox" className="form-check-input" id="cookieCheck" required />
                <label className="form-check-label" htmlFor="cookieCheck">
                  I accept the use of cookies.
                </label>
              </div>
            </div>

            <div className="form-group mt-3 mb-3">
              <div className="d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey={SITE_KEY}
                  onChange={(token) => setRecaptchaValue(token)}
                  ref={captchaRef}
                  id="captcha-register"
                />
              </div>
            </div>

            <button
              id="register_button"
              type="submit"
              className="btn btn-primary w-100 py-2"
              disabled={isLoading}
            >
              {isLoading ? 'Creating...' : 'REGISTER'}
            </button>

            <hr className="my-4" />

            <p className="text-center small text-secondary mb-2">
              <Link to="/login">Already have an account? Sign In</Link>
            </p>
            <p className="text-center small text-secondary">
              <Link to="/driver/register">Register as a Driver?</Link>
            </p>
          </form>
        </div>
      </div>
    </>
  );
};

export default Register;